// Central E-E-A-T config. Powers author/reviewer bylines + Organization/reviewedBy
// schema across public pages. Populated with the Sarv Health Team now; swap in a
// named credentialed reviewer later (Person schema) with no other code changes.
export const ORG = {
  name: "Sarv",
  url: "https://joinsarv.com",
  logo: "https://joinsarv.com/v.png",
  sameAs: [
    "https://www.facebook.com/joinsarv",
    "https://www.instagram.com/joinsarv/",
  ],
};

// The current reviewer entity. To name a real reviewer later, change `type` to
// "Person" and add name/jobTitle/credentials — the schema + byline pick it up.
export const REVIEWER = {
  type: "Organization",
  name: "The Sarv Health Team",
};

export const EDITORIAL_PATH = "/editorial-process";

// Organization schema — emit once sitewide (homepage) for knowledge-panel + trust.
export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: ORG.name,
  url: ORG.url,
  logo: { "@type": "ImageObject", url: ORG.logo },
  sameAs: ORG.sameAs,
});

// reviewedBy value for MedicalWebPage schema.
export const reviewerSchema = () => ({ "@type": REVIEWER.type, name: REVIEWER.name });

export default ORG;
